import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import RaisedButton from "material-ui/RaisedButton"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import { IAccountManagerFESettings } from "../../models/data/account_manager/AccountManagerFESettings"
import * as api from "../../api"
import PasswordField from "../../components/common/PasswordField"
import AppStateStore from "../../stores/AppStateStore"
import * as appStateActions from "../../actions/AppStateActions"

interface IState {
    password: string
    validPassword: boolean
    tokenNotFound: boolean
    token: string
    email: string
    loading: string
    errorSettingPassword: boolean
    successSettingPassword: boolean
    frontEndSettings: IAccountManagerFESettings
}

export default class VerifyEmail extends React.Component<null, IState> {
    constructor(props) {
        super(props)
        this.state = {
            password: "",
            validPassword: false,
            tokenNotFound: new URLSearchParams(location.search).get("t") === null,
            token: new URLSearchParams(location.search).get("t"),
            email: new URLSearchParams(location.search).get("e"),
            errorSettingPassword: false,
            successSettingPassword: false,
            loading: null,
            frontEndSettings: null,
        }
        autobind(this)
        this.verifyEmail()
    }

    componentWillMount() {
        AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
        appStateActions.getFrontEndSettings()
    }

    componentDidMount(): void {
        document.title = `Verify Email | ${strings.Findd_Grandd_Central}`
    }

    frontEndSettingsChange() {
        this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
    }

    verifyEmail() {
        if (this.state.token && this.state.email) {
            api.verifyEmail(this.state.email, this.state.token)
        }
    }

    handleRequestSetPassword() {
        this.state.validPassword &&
            this.setState({ loading: "Saving password" }, () =>
                api.resetPassword(this.state.token, this.state.password, false).then(res =>
                    this.setState({
                        loading: null,
                        successSettingPassword: res.data,
                        errorSettingPassword: !res.data,
                    })
                )
            )
    }

    render() {
        if (!this.state.frontEndSettings) {
            return (
                <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%" }}><div style={{ padding: 20 }}>{strings.loading}</div></div>
            )
        }

        const setPasswordForm = (
            <div>
                <p>Your email has been verified. To activate your account, please create your password.</p>
                <h2>Create your password</h2>
                <PasswordField
                    password={this.state.password}
                    handleChange={(password, validPassword) => this.setState({ password, validPassword })}
                    handleSave={(password, validPassword) => this.setState({ password, validPassword }, () => this.handleRequestSetPassword())}
                />
                <div style={{ marginTop: 50 }}>
                    <RaisedButton
                        data-intercom-target={"AccountManagerDrawer-Btn-save"}
                        disabled={!this.state.validPassword}
                        backgroundColor="#1181F2"
                        labelColor="white"
                        label={strings.Finish}
                        onTouchTap={() => this.handleRequestSetPassword()}
                        style={{ width: "100%" }}
                    />
                </div>
            </div>
        )

        const tokenNotFound = (
            <div>
                <h2>Error: Invalid user token.</h2>
                <p>Click below to reset your password.</p>
                <a href="/forgot_password">Reset Password</a>
            </div>
        )

        const errorSettingPassword = (
            <div>
                <h2>Error Setting Password</h2>
                <p>Your password reset token may have expired. Click below to reset your password again via email.</p>
                <a href="/forgot_password">Reset Password</a>
            </div>
        )

        const successSettingPassword = (
            <div>
                <h2>Password Updated!</h2>
                <p>Your password has been set and your account is now active and ready for you to login. Click below to start using Findd!</p>
                <a href="/login">Login To Findd</a>
            </div>
        )

        let leftContainer = this.state.tokenNotFound ? tokenNotFound : setPasswordForm

        if (this.state.errorSettingPassword) {
            leftContainer = errorSettingPassword
        } else if (this.state.successSettingPassword) {
            leftContainer = successSettingPassword
        }

        return (
            <RegistrationLayout
                leftContainer={leftContainer}
                rightContainer={<img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/password-graphic.png" style={{ position: "absolute", top: "30%", width: "50%", left: "25%" }} />}
                loading={this.state.loading}
                frontEndSettings={this.state.frontEndSettings}
            />
        )
    }
}